import { defineStore } from 'pinia'
import { ref, Ref } from 'vue'

import { notifications_realisation } from '@/core/realisations/notifications.realisation'
import { NotificationT } from '@/core/types/notifications.types'

export const useNotificationsStore = defineStore('notifications-store', () => {
    const is_window_opened = ref(true)

    const is_loading = ref(false)
    const is_failed = ref(false)

    const notifications = ref([]) as Ref<NotificationT[]>

    const current_page = ref(1)
    const total_pages = ref(1)

    const openWindow = () => {
        is_window_opened.value = true
    }

    const closeWindow = () => {
        is_window_opened.value = false
    }

    const loadNotifications = async (params: any = { page: 1 }) => {
        current_page.value = params.page
        notifications.value = []

        try {
            is_loading.value = true

            const response = await notifications_realisation.getNotificationsList(params)
            notifications.value = response.data
            total_pages.value = response.meta.last_page

            is_failed.value = false
        } catch (error) {
            console.error(error)
            is_failed.value = true
        } finally {
            is_loading.value = false
        }
    }

    return {
        is_window_opened,
        is_loading,
        is_failed,
        notifications,
        current_page,
        total_pages,
        openWindow,
        closeWindow,
        loadNotifications,
    }
})
